import { useEffect, useRef } from 'react';

import { playingContentIdVar } from './use-playing-content-id-var';

export const usePlayingContentIdChangeHandler = ({ onChange }: { onChange: () => void }) => {
    const prevPlayingContentId = useRef<string | null>(null);
    const playingContentId = playingContentIdVar.get();

    useEffect(() => {
        if (prevPlayingContentId.current !== playingContentId) {
            if (prevPlayingContentId.current) {
                onChange();
            }

            prevPlayingContentId.current = playingContentId;
        }
    }, [playingContentId, onChange]);
};
